var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box text-center text-danger"},[_c('h1',[_c('account-off-icon')],1),_vm._v(" 该账户已被冻结\n")])}
var staticRenderFns = []

export { render, staticRenderFns }